NtechApp.LoginForm = function() {
    this._ajax = new NtechApp.Ajax();
    this._click = new NtechApp.TouchClickEvent();
    this._formDataParser = new NtechApp.FormDataParser();

    this._form = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
    this._form.setFormView($("#loginForm"));

    this._$form = this._form.getFormView();
    NtechApp.lockScroll(this._$form);

    this._loader = null;
    this._updateHeightTimeout = null;

    this._bindEvents();
};

NtechApp.LoginForm.EVENT_WINDOW_RESIZE = "resize.NtechApp.LoginForm";

NtechApp.proto(NtechApp.LoginForm, {
    _bindEvents: function() {
        var me = this;
        var $el = $("body").find('[data-eventWatcher="auth"]');

        this._click.listen($el, '[data-eventAction="openLoginForm"]', function(event) {
            event.preventDefault();

            me.loadLoginForm();
            return false;
        });
    },

    _bindFormEvents: function($form, showFn) {
        var me = this;

        var $formContent = $form.find(".formContent");
        var $scrollableFormContent = $form.find(".scrollableFormContent");

        $(window).on(NtechApp.LoginForm.EVENT_WINDOW_RESIZE, function() {
            me._centrifyForm($form);
            me._updateOverlayBgHeight($form);
        });

        me._click.listen($form, ".closeButtonWrap", function() {
            me._unloadForm(true);
        });

        me._loader = new NtechApp.Loader(18, 18, "absolute", $form.find(".loaderWrap"));
        me._loader.getView().css({
            background: '#37bdb1',
            borderRadius: '19px'
        });
        me._loader.white();

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm(true);
        });

        me._click.listen(this._$form, "[data-submit]", function(event) {
            event.preventDefault(); 
            me._login.call(me);

            return false;
        });

        me._click.listen(this._$form, ".formErrors", function(event) {
            $(event.target).closest(".formErrors").css("display", "none");
        });

        me._updateOverlayBgHeight($form);
    },

    _updateOverlayBgHeight: function($form) {
        var newHeight = $form.find(".loginContent").outerHeight() + $form.find(".loginContent").offset().top;
        var vpHeight = $(window).height();

        if(newHeight < vpHeight)
            newHeight = vpHeight;
        
        $form.find(".overlayBg").css("height", newHeight + "px");
        $form.find(".loginBg").css("height", newHeight + "px");
    },

    _centrifyForm: function($form, forceFormPrerender) {
        var forceFormPrerender = forceFormPrerender || false;

        if(forceFormPrerender) { 
            $form.css({
                display: "block",
                visibility: "hidden",
                left: "100%"
            }); 
        }
        
        var contentHeight = $form.find(".loginContent").outerHeight();
        //var logoOffsetBottom = $form.find(".logo").offset().top + $form.find(".logo").outerHeight();
        var logoOffsetBottom = $form.find(".closeButtonWrap").outerHeight() + $form.find(".logo").outerHeight();
        logoOffsetBottom -= 50; // Additional spacer
        var vpHeight = $(window).height();

        if(logoOffsetBottom + contentHeight < vpHeight) {
            var marginTop = (vpHeight - contentHeight) / 2 - logoOffsetBottom;
            if(marginTop < 0)
                marginTop = 0;
            
            $form.find(".loginContent").css({marginTop: marginTop + "px"});
        }
        else {
            $form.find(".loginContent").css({marginTop: "0px"});
        }

        if(forceFormPrerender) {
            $form.css({
                display: "none",
                visibility: "visible",
                left: "0%"
            });
        }
    },

    loadLoginForm: function() {
        var me = this;
        
        me._centrifyForm($("#loginForm"), true);
        me._form.load("load_login_form", function($form) {
            me._$form = $form;
            me._bindFormEvents.call(me, $form);
        });

        clearTimeout(me._updateHeightTimeout);
        me._updateHeightTimeout = setTimeout(function() {
            me._updateOverlayBgHeight(me._$form);
        }, 400);
    },

    _unloadForm: function(keepEvents) {
        clearTimeout(this._updateHeightTimeout);

        var keepEvents = keepEvents || false;
        this._form.unload();

        if(!keepEvents) {
            $(window).off(NtechApp.LoginForm.EVENT_WINDOW_RESIZE);
            this._form.destroy();
        }
    },

    _enableLoader: function() {
        this._loader.on();
    },

    _disableLoader: function() {
        this._loader.off();
    },

    _login: function() {
        var route = "auth_login_check";
        var $form = this._$form.find("form");

        this._loginToAccount($form, route);
    },

    _loginToAccount: function($form, route) {
        var me = this;

        this._enableLoader();
        var formData = {
            loginData: this._formDataParser.getFormJSON($form)
        };

        this._ajax.post({
            url: Routing.generate(route),
            data: formData,
            onSuccess: function(data) {
                window.location.href = data.targetUrl;
            },
            onError: function(errors) {
                var $formErrors = me._$form.find(".formErrors");
                var html = "";

                $formErrors.find(".errorBody").children().remove();
                for(var key in errors) {
                    var errText = errors[key];
                    html += "<p>" + errText + "</p>";
                }

                $formErrors.find(".errorBody").append($.parseHTML(html));
                $formErrors.css("display", "block");
            },
            onComplete: function() {
                me._disableLoader();
            }
        });
    }
});